module.exports = __webpack_public_path__ + "img/vlru.5b2720c8.png";